/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'fabric.editor.headingLink.ascSortingLabel': 'stigende',
  'fabric.editor.headingLink.copied': 'Kopieret!',
  'fabric.editor.headingLink.copyAnchorLink': 'Kopiér link til overskrift',
  'fabric.editor.headingLink.copyAriaLabel': 'Kopiér',
  'fabric.editor.headingLink.descSortingLabel': 'faldende',
  'fabric.editor.headingLink.failedToCopy': 'Kopiering mislykkedes',
  'fabric.editor.headingLink.noneSortingLabel': 'ingen',
  'fabric.editor.inlineComment.marker.end': 'slut på indlejret kommentar',
  'fabric.editor.inlineComment.marker.start': 'start på indlejret kommentar',
};
